/**
 * @generated SignedSource<<95164a8fa864ceba930cb4476f09529f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DashboardCard_machinesCountByStatusQuery$variables = {};
export type DashboardCard_machinesCountByStatusQuery$data = {
  readonly machinesCountByStatus: {
    readonly commerciallyDeploy: number;
    readonly deployedMachines: number;
    readonly inProduction: number;
    readonly inRepair: number;
    readonly readyAtCm: number;
    readonly readyToDeploy: number;
  };
};
export type DashboardCard_machinesCountByStatusQuery = {
  response: DashboardCard_machinesCountByStatusQuery$data;
  variables: DashboardCard_machinesCountByStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MachinesCountByStatusObjectType",
    "kind": "LinkedField",
    "name": "machinesCountByStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deployedMachines",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "commerciallyDeploy",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "readyToDeploy",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "inRepair",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "readyAtCm",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "inProduction",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardCard_machinesCountByStatusQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DashboardCard_machinesCountByStatusQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4e363caf63993acd25606c44bb914beb",
    "id": null,
    "metadata": {},
    "name": "DashboardCard_machinesCountByStatusQuery",
    "operationKind": "query",
    "text": "query DashboardCard_machinesCountByStatusQuery {\n  machinesCountByStatus {\n    deployedMachines\n    commerciallyDeploy\n    readyToDeploy\n    inRepair\n    readyAtCm\n    inProduction\n  }\n}\n"
  }
};
})();

(node as any).hash = "e4115e0483cbc46e612218d2c5bb34c9";

export default node;
